import { ZonesKpisActionTypes } from './constants';

type ZonesKpisAction = { type: string, payload: {} | string };

export const zonesKpisApiResponseSuccess = (actionType: string, data: any): ZonesKpisAction => ({
    type: ZonesKpisActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});

export const zonesKpisApiResponseError = (actionType: string, error: string): ZonesKpisAction => ({
    type: ZonesKpisActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const zonesKpisGetAvgDomesticZone = (query: string): ZonesKpisAction => ({
    type: ZonesKpisActionTypes.GET_AVERAGE_DOMESTIC_ZONE,
    payload: { query },
});

export const zonesKpisGetZoneCount = (query: string): ZonesKpisAction => ({
    type: ZonesKpisActionTypes.GET_ZONES_COUNT,
    payload: { query },
});

export const zonesKpisGetDomesticZonesByTimeframe = (query: string): ZonesKpisAction => ({
    type: ZonesKpisActionTypes.GET_DOMESTIC_ZONES_BY_TIMEFRAME,
    payload: { query },
});

export const zonesKpisGetZonesShipmentsCost = (query: string): ZonesKpisAction => ({
    type: ZonesKpisActionTypes.GET_ZONES_SHIPMENTS_COST,
    payload: { query },
});